import React from "react";

import WComponent from "../common/WComponent";
import PlaybookInputFieldService from "../../services/PlaybookInputFieldService";

import "./build-page.css";
import "./playbook-build-page.css";

const KIND_WORDS = {
	money: "an amount",
	number: "a number",
	date: "a date",
	month: "a month",
	yesNo: "yes or no",
	text: "text",
};

class PlaybookBuildInputsCard extends WComponent {
	listedFields() {
		const { session } = this.props;
		const { draft } = session;
		if (draft) {
			const draftFields = PlaybookInputFieldService.fieldsOf({ version: draft });
			return draftFields;
		}
		const suggestedFields = session.suggestedInputFields || [];
		return suggestedFields;
	}

	describeKind({ field }) {
		if (field.kind === "choice") {
			const choices = field.choices || [];
			const choiceNames = choices.map(choice => PlaybookInputFieldService.describeFieldValue({ field, value: choice }));
			const choiceWords = `one of: ${choiceNames.join(" or ")}`;
			return choiceWords;
		}
		const kindWords = KIND_WORDS[field.kind] || field.kind;
		return kindWords;
	}

	describeDefault({ field }) {
		const startingValues = PlaybookInputFieldService.initialValues({ fields: [field] });
		const startingValue = startingValues[field.key];
		if (startingValue === "") return null;
		if (field.kind === "money") {
			const shownAmount = `$${startingValue}`;
			return shownAmount;
		}
		const shownDefault = PlaybookInputFieldService.describeFieldValue({ field, value: startingValue });
		return shownDefault;
	}

	describeFills({ field }) {
		const { session } = this.props;
		const draftTools = session.draft ? session.draft.tools || [] : [];
		const suggestedTools = session.suggestedTools || [];
		const knownTools = [...draftTools, ...suggestedTools];
		const fills = field.fills || [];
		const toolNames = fills.map(fill => fill.toolName);
		const uniqueToolNames = [...new Set(toolNames)];
		const toolLabels = uniqueToolNames.map(toolName => {
			const tool = knownTools.find(candidate => candidate.name === toolName);
			const toolLabel = tool ? tool.label : toolName;
			return toolLabel;
		});
		if (toolLabels.length === 0) return null;
		const fillsWords = `Fills: ${toolLabels.join(", ")}`;
		return fillsWords;
	}

	renderField = field => {
		const kindWords = this.describeKind({ field });
		const shownDefault = this.describeDefault({ field });
		const fillsWords = this.describeFills({ field });
		const needWords = field.isRequired ? "required" : "optional";
		const defaultWords = shownDefault !== null ? ` · Default: ${shownDefault}` : "";

		return (
			<div key={field.key} className="playbook-build__source">
				<div className="playbook-build__source-text">
					<span className="playbook-build__source-name">
						{field.label} <span className="tk-muted">{needWords}</span>
					</span>
					<span className="tk-muted">
						{kindWords}
						{defaultWords}
					</span>
					{fillsWords && <span className="tk-muted">{fillsWords}</span>}
				</div>
			</div>
		);
	};

	renderFieldGap = (fieldGap, index) => {
		const quotedLabel = `"${fieldGap.label}"`;
		const isAlreadyNamed = !fieldGap.label || fieldGap.sentence.startsWith(quotedLabel);
		const noteText = isAlreadyNamed ? fieldGap.sentence : `${quotedLabel}: ${fieldGap.sentence}`;
		return (
			<p key={index} className="tk-notice__detail">
				{noteText}
			</p>
		);
	};

	render() {
		const { session } = this.props;
		const fields = this.listedFields();
		const fieldGaps = session.fieldGaps || [];
		const hasFields = fields.length > 0;
		const hasFieldGaps = fieldGaps.length > 0;
		if (!hasFields && !hasFieldGaps) return null;

		return (
			<section className="build-card tk-card">
				<div className="build-card__head">
					<span className="build-card__title">Run inputs</span>
					<span className="tk-muted">what a person fills in to run it</span>
				</div>
				{fields.map(this.renderField)}
				{hasFieldGaps && (
					<div className="tk-notice tk-notice--warning">
						<div className="tk-notice__title">Left out of the form</div>
						{fieldGaps.map(this.renderFieldGap)}
					</div>
				)}
			</section>
		);
	}
}

export default PlaybookBuildInputsCard;
